module.exports = __webpack_public_path__ + "img/Weapon_57.0b3b6655.png";